import { createSelector } from 'reselect';
import { accessColumnData } from '../transform';
import getFilteredTagsOfArea from './getFilteredTagsOfArea';

const getSorting = state => state.tags.sorting;

const sortStrings = (a, b) => {
  return a.localeCompare(
    b,
    'en-US',
    { numeric: true, sensitivity: 'base' }
  );
}

/**
  @name getFilteredSortedTagsOfArea
  Selector to obtain the filtered and sorted list of tags
*/
const getFilteredSortedTagsOfArea = createSelector(
  [getFilteredTagsOfArea, getSorting],
  (tags, sorting) => {
    const { column, descendingOrder } = sorting;
    const result = Array.from(tags);
    if (typeof column.sorter === 'function') {
      const sorter = column.sorter;
      return result.sort((a, b) =>
        descendingOrder ? sorter(b, a) : sorter(a, b)
      );
    } else {
      return result.sort((a, b) => {
        const valueA = accessColumnData(a, column).toUpperCase();
        const valueB = accessColumnData(b, column).toUpperCase();
        return descendingOrder ? sortStrings(valueB, valueA) : sortStrings(valueA, valueB);
      });
    }
  }
);

export default getFilteredSortedTagsOfArea;



// WEBPACK FOOTER //
// ./src/utils/selectors/getFilteredSortedTagsOfArea.js